import React from 'react';
import { Icon } from 'antd';
import { FormField, isStepValid } from 'utils/registration/formUtils';
import AA from 'actions/dod/dodAuthorizationActions';
import fields from 'utils/registration/dod/fields/authorizationFields';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const f = fields;
const { getDataType } = ssCommonUtils;

const init = {
    status: 'invalid',
    description: 'Signature & Authorization',
    title: (
        <div>
            <Icon type='edit' />
            {' Step 6'}
        </div>
    ),
    forms: {
        signature: new FormField(f.signature),
        understandAndAgree: new FormField(f.understandAndAgree),
        designeeLetter: new FormField(f.designeeLetter)
    }
},
postFieldFormatter = (f) => {
    switch(f.formProp) {
        case 'understandAndAgree': return new FormField({...f,
            field: {...f.field, checked: f.field.value, value: '' }
        });
        case 'designeeLetter': return new FormField({...f,
            letter: getDataType(f.field.value) === 'File' && f.form.validateStatus === 'success' ? f.field.value : null,
            field: {...f.field, value: '' }
        });

        default: return f;
    }
};

export default (state=init, action) => {
    switch(action.type) {
        case AA.UPDATE_DOD_AUTHORIZATION_FIELD:
            // Narrowing scope deliberately.
            return ((s, a) => ({...s,
                status: isStepValid(s, a.payload) ? 'valid' : 'invalid',
                forms: {...s.forms, [a.payload.formProp]: postFieldFormatter(a.payload)
            }}))(state, action)

        case AA.UPDATE_DOD_AUTHORIZATION_TITLE:
            return {...state, title: action.payload };

        default: return {...state};
    }
}
